import { useEffect } from 'react'
import { atom, useAtom } from 'jotai'

import { useDebug } from '@/views/debug'

const undoData = atom<{
    appliancePlanId: number, // works only for one appliance plan atm
    allDosesAdded: boolean, // to make undo button disabled until all doses are added
    addedDoses: number[]
}>({
    appliancePlanId: 0,
    allDosesAdded: false,
    addedDoses: []
})

export function useDoseAddUndo(appliancePlanId: number) {
    const debug = useDebug({ name: 'useDoseAddUndo' })

    const [data, setData] = useAtom(undoData)

    // Works only for one appliance plan atm, so clear data if that ID changed
    useEffect(() => {
        if(data.appliancePlanId !== appliancePlanId){

            debug.log(`appliance plan id changed -> reset!, ${data.appliancePlanId} -> ${appliancePlanId}`)

            setData({
                appliancePlanId: appliancePlanId,
                allDosesAdded: false,
                addedDoses: [],
            })
        }
    }, [appliancePlanId])

    return {
        beginAdding: () => {
            debug.log('beginAdding')

            setData(data => ({
                ...data,
                allDosesAdded: false,
                addedDoses: []
            }))
        },
        addDose: (doseId: number) => {
            debug.log('addDose', doseId)

            setData(data => ({
                ...data,
                addedDoses: [...data.addedDoses, doseId]
            }))
        },
        endAdding: () => {
            debug.log('endAdding', data)

            setData(data => ({
                ...data,
                allDosesAdded: true,
            }));
        },

        doseIdArrayToDelete: (): number[] => {
            return data.addedDoses
        },

        isDisabled: () => {
            // Also don't enable until all doses are duplicated
            const isEnabled = data.addedDoses.length > 0 && data.allDosesAdded
            return !isEnabled
        },

        clear: () => {
            setData(data => ({
                ...data,
                allDosesAdded: false,
                addedDoses: []
            }))
        },
    }
}
